var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "item-add-dialog",
          attrs: {
            id: "item-add-dialog",
            title: "Zutat / Material hinzufügen",
            busy: _vm.isSaving,
          },
          on: { ok: _vm.submitForm, hide: _vm.close },
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                description: "Bitte Zutat oder Material auswählen",
                label: "Zutat / Material",
                "label-for": "add-ingrecient-select",
                "invalid-feedback": _vm.ingredientFeedback,
                state: _vm.ingredientState,
              },
            },
            [
              _c("v-multiselect", {
                attrs: {
                  id: "add-ingrecient-select",
                  options: _vm.filterOptions.ingredients,
                  "track-by": "value",
                  label: "text",
                  "show-labels": false,
                  searchable: true,
                  disabled: _vm.isSaving,
                },
                model: {
                  value: _vm.ingredient,
                  callback: function ($$v) {
                    _vm.ingredient = $$v
                  },
                  expression: "ingredient",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                description: "Bitte Zutat oder Material auswählen",
                label: "Menge",
                "label-for": "add-ingredient-amount",
                "invalid-feedback": _vm.amountFeedback,
                state: _vm.amountState,
              },
            },
            [
              _c(
                "b-input-group",
                {
                  attrs: {
                    append: _vm.ingredient
                      ? _vm.ingredient.base_unit_title
                      : "Einheit",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "number",
                      step: Math.pow(
                        10,
                        (_vm.ingredient
                          ? _vm.ingredient.base_unit_precision
                          : 1) * -1
                      ),
                      disabled: _vm.isSaving,
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submitDelta.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.amount,
                      callback: function ($$v) {
                        _vm.amount = $$v
                      },
                      expression: "amount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }